import Client from '../entities/Client';
import API from './API';
import Axios from 'axios';

this.getAll = (callback) => {
    try {
        Axios.get(API.getAllClients).then((response) => callback(response.data.Items));
    } catch (error) {
        console.error(error);
    }
}

export default { getAll: this.getAll };



// WEBPACK FOOTER //
// ./src/gateway/ClientGateway.js